import type { IconData } from '@stacksjs/iconify-core'

export const linkBroken: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M288 496h32V368h128v-32H288zm-64-320V16h-32v128H64v32zM78.708 434.573l-1.279-1.273a100.48 100.48 0 0 1 0-142.1l75.2-75.2h-45.257L54.8 268.57a132.48 132.48 0 0 0 0 187.35l1.278 1.278a132.63 132.63 0 0 0 187.352 0l4.57-4.57v-45.255l-27.2 27.2a100.59 100.59 0 0 1-142.092 0M457.2 56.08l-1.278-1.28c-51.653-51.655-135.7-51.653-187.352 0L264 59.372v45.255l27.2-27.2a100.59 100.59 0 0 1 142.095 0l1.279 1.278a100.48 100.48 0 0 1 0 142.1l-75.2 75.2h45.253L457.2 243.43a132.48 132.48 0 0 0 0-187.35\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default linkBroken
